import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCountdown } from '../../hooks/use-countdown';

interface ICountdownOverlayProps {
  nextAt?: number;
}

export const CountdownOverlay: FC<ICountdownOverlayProps> = ({ nextAt }) => {
  const { t } = useTranslation();
  const { label, remaining } = useCountdown(nextAt);
  if (!nextAt || remaining <= 0) return null;

  return (
    <div className="absolute inset-0 -left-4 -right-4 flex items-center justify-center bg-black/60 backdrop-blur-sm sm:left-0 sm:right-0 sm:rounded-2xl">
      <div className="flex flex-col items-center justify-center text-3xl font-semibold text-white-text">
        <p className="text-base font-semibold text-[#fff]">{t('pages.dailyQuests.newChestIn')}</p>
        <p className="gradient-text inline-flex text-3xl font-bold">
          {label.split('').map((char, i) => (
            <span key={i} className="inline-block w-[1ch] text-center">
              {char}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};
